// Application modules
import AuthModule from './auth';
import ApiModule from './api';
// Application services
import AppServicesModule from './app';

/*
import CookiesService from './cookies.service';
import CookiesService2 from './cookies.service.2';
import MessagesService from './messages.service';

import SharedService from './app/shared.service';
import AlertsService from './app/alerts.service';
import HttpInterceptor from './app/httpInterceptor';

// Models
import AccountModelService from './models/account.model.service';
import PanelsModelService from './models/panels.model.service';*/


export default angular.module(
	'app.services.module',
	[
		AuthModule,
		ApiModule,
		AppServicesModule
	])

	/*.service('MessagesService', MessagesService)
	.service('CookiesService2', CookiesService2)
	.service('CookiesService', CookiesService)*/

	.name;






/*.service('SharedService', SharedService)
 .service('AlertsService', AlertsService)

 //.factory('HttpInterceptorFactory', HttpInterceptor) // For preloader

 .service('AccountModel', AccountModelService)
 .service('PanelsModel', PanelsModelService)*/


/** WEBPACK FOOTER **
 ** ./src/services/index.js
 **/